const AUTH_STORAGE_KEY = "ieee_auth_session";
const RESET_TOKEN_KEY = "ieee_reset_token";
const ACTIVE_TRACK_KEY = "ieee_active_track_id";
const ACTIVE_TASK_KEY = "ieee_active_task_id";

export function getStoredSession() {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw) return { token: null, user: null };

    const parsed = JSON.parse(raw);
    return {
      token: parsed?.token || null,
      user: parsed?.user || null,
    };
  } catch {
    return { token: null, user: null };
  }
}

export function saveSession(token, user) {
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify({ token, user }));
}

export function clearSession() {
  localStorage.removeItem(AUTH_STORAGE_KEY);
}

export function getAccessToken() {
  return getStoredSession().token;
}

export function saveResetToken(token) {
  if (token) {
    sessionStorage.setItem(RESET_TOKEN_KEY, token);
  }
}

export function getResetToken() {
  return sessionStorage.getItem(RESET_TOKEN_KEY);
}

export function clearResetToken() {
  sessionStorage.removeItem(RESET_TOKEN_KEY);
}

export function setActiveTrackId(trackId) {
  if (!trackId) return;
  localStorage.setItem(ACTIVE_TRACK_KEY, trackId);
}

export function getActiveTrackId() {
  return localStorage.getItem(ACTIVE_TRACK_KEY);
}

export function clearActiveTrackId() {
  localStorage.removeItem(ACTIVE_TRACK_KEY);
}

export function setActiveTaskId(taskId) {
  if (!taskId) return;
  sessionStorage.setItem(ACTIVE_TASK_KEY, taskId);
}

export function getActiveTaskId() {
  return sessionStorage.getItem(ACTIVE_TASK_KEY);
}

export function clearActiveTaskId() {
  sessionStorage.removeItem(ACTIVE_TASK_KEY);
}
